import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExpirationService {
  private sessionExpired = false;

  setSessionExpired(expired: boolean) {
    this.sessionExpired = expired;
  }

  isSessionExpired(): boolean {
    return this.sessionExpired;
  }
}
